export const FULL_ACCESS = "F";
export const READONLY_ACCESS = "R";
